<template>
  <div class="text-center">
    <router-link
      v-if="!openInNewWindow"
      :to="routePath"
      class="plain-link"
      @click="emitEvent"
    >
      <v-btn large text class="normal-text">
        <v-icon :icon="icon" small class="normal-icon mr-1">{{ icon }}</v-icon>
        {{ text }}
      </v-btn>
    </router-link>
    <a v-else :href="routePath" target="_blank" class="plain-link">
      <v-btn large text class="normal-text">
        <v-icon :icon="icon" small class="normal-icon mr-1">{{ icon }}</v-icon>
        {{ text }}
      </v-btn>
    </a>
  </div>
</template>

<script>
export default {
  props: {
    item: {
      type: Object,
      required: true
    },
    openInNewWindow: {
      type: Boolean,
      default: false
    },
    routeName: {
      type: String,
      required: true
    },
    routeParams: {
      type: Object,
      default: () => ({})
    },
    event: {
      type: String,
      default: 'show'
    },
    icon: {
      type: String,
      default: 'mdi-eye'
    },
    text: {
      type: String,
      default() {
        return this.$t('ITEM.VIEW');
      }
    }
  },
  computed: {
    routePath() {
      return this.$router.resolve({
        name: this.routeName,
        params: this.routeParams
      }).href;
    }
  },
  methods: {
    emitEvent() {
      this.$emit(this.event, this.item);
    }
  }
};
</script>

<style scoped>
.plain-link {
  text-decoration: none;
  color: inherit;
}

.plain-link:hover {
  text-decoration: none;
  color: inherit;
}

.normal-icon {
  color: rgba(0, 0, 0, 0.54) !important;
}

.normal-text {
  font-weight: normal !important;
  letter-spacing: normal;
  color: rgba(0, 0, 0, 0.87);
  font-size: 1rem;
  text-transform: none;
  white-space: nowrap;
}
</style>
